import { PaginatedTableCellModel, PaginatedTableRowModel } from '@lucky7ventures/lucky-components';
import { BUILD_MODE, envIsCanada } from '@/constants/constants';
import { BffLoginHistory } from '@lucky7ventures/bff-types';

export const loginsToTableRowData = (logins: BffLoginHistory[]): PaginatedTableRowModel[] => {
  if (!logins) {
    return [];
  }

  return logins.map(login => {
    let cells: PaginatedTableCellModel[] = [
      {
        text: new Date(login.dateCreated).toLocaleDateString(),
        subtext: new Date(login.dateCreated).toLocaleTimeString(),
      },

      {
        text: login.isInvalidated ? new Date(login.lastAccess).toLocaleDateString() : '-',
        subtext: login.isInvalidated ? new Date(login.lastAccess).toLocaleTimeString() : undefined,
        align: 'right',
      },
    ];

    if (envIsCanada()) {
      cells.push(
        {
          text: login.sessionData?.TotalWagered ?? '-',
          align: 'right',
        },
        {
          text: login.sessionData?.TotalWon ?? '-',
          align: 'right',
        },
        {
          text: login.sessionData?.TotalLost ?? '-',
          align: 'right',
        },
        {
          text: login.sessionData?.BalanceStart ?? '-',
          align: 'right',
        },
        {
          text: login.sessionData?.BalanceEnd ?? '-',
          align: 'right',
        },
        {
          text: login.sessionData?.NetPosition ?? '-',
          align: 'right',
        },
        {
          text: login.sessionData?.Currency ?? '-',
          align: 'right',
        },
      );
    }
    return {
      id: login.token,
      cells: cells,
    };
  });
};

export const mapLocaleToPathLocale = (locale: string): string => {
  if (BUILD_MODE === 'canada') {
    if (locale === 'ca-fr') {
      return 'fr';
    }
  }

  return locale;
};

export const mapLocaleToFile = (locale: string): string => {
  switch (locale) {
    case 'eu':
      return 'en';
    case 'row':
      return 'en';
    case 'ca-fr':
      return 'fr';
    case 'at':
      return 'de';
    default:
      return locale;
  }
};

export const localeToCountry = (locale: string) => {
  switch (locale) {
    case 'no':
      return 'Norway';
    case 'fi':
      return 'Finland';
    case 'at':
      return 'Austria';
    case 'nz':
      return 'New Zealand';
    case 'ca':
      return 'Canada';
    case 'ca-fr':
      return 'Canada';
    case 'za':
      return 'South Africa';
    case 'ae':
      return 'United Arab Emirates';
    case 'th':
      return 'Thailand';
    case 'fi-en':
      return 'Finland';
    default:
      return 'Rest of World';
  }
};
